import axios from "axios";
import store from '@/store/store'

// You can use your own logic to set your local or production domain
// const baseDomain = "http://127.0.0.1:8000";
// The base URL is empty this time due we are using the jsonplaceholder API
// const baseURL = "https://admin.userist.idist.ai/";
const baseURL = "http://127.0.0.1:7001/";
// let token = $cookies.get("token")
// console.log(axios.defaults.headers);

const httpClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
})


/**
 * Adding the response interceptors
 * https://medium.com/js-dojo/how-to-handle-http-calls-in-a-large-scale-vue-js-application-26629158f60e
 * 
 */

httpClient.interceptors.response.use(
  // SUCCESS response interceptors
  response => {
    return response;
  },
  // ERROR response interceptors
  error => {
    if (error.response) {
      store.state.errorHandling.error_code = error.response.status
      store.state.errorHandling.show_error = true
      return Promise.reject(error);
    } else {
      store.state.errorHandling.server_down = true
      store.state.errorHandling.show_error = true
      return Promise.reject(error);
    }
  }
);

export default httpClient
